import $ from 'jquery'
import Contrat from '@/views/mdt/societe/societeDetails/ajout-contrat'
import Travailleurs from '@/views/mdt/travailleurs'
import RompreContrat from '@/views/mdt/societe/rompre-contrat'
import Parametrages from '@/views/mdt/parametrages' 
import ParamVisiteMedicale from '@/views/mdt/societe/societeDetails/parametrages-visites-medicales'
import ParametrageSociete from '@/views/mdt/societe/societeDetails/parametrages'
import VisiteMedicale from '@/views/mdt/societe/societeDetails/visites-medicales'
import HistoriqueVisitesMedicales from '@/views/mdt/societe/societeDetails/historique-visites-medicales'

import NProgress from 'nprogress'
import store from '@/store'
import moment from 'moment';
// import image from "@/assets/company_logo.png"

export default {
    name: 'societe-details',
    components: { 
        Travailleurs, Contrat,
        RompreContrat, Parametrages,ParamVisiteMedicale,
        VisiteMedicale,ParametrageSociete,HistoriqueVisitesMedicales
    },
    props: [],
    data() {
        return {
            asset_url: '',
            // asset_url: 'http://192.168.1.169/schilo/SCH_CLINIQUE/public/index.php/assets/files',
            contrat: '',

            canReconduireContrat: Boolean,
            canRompreContrat: Boolean,

            societe_id: null //  ID du contrat 0 rompre
        }
    },
    async beforeRouteEnter(to, from, next) {

        NProgress.start()

        store.dispatch("getSociete", to.params.id).then(
            async () => {
                await store.dispatch("getSocieteCurrentVisiteMedicale",to.params.id).then(
                    async response => {
                        if(  Object.keys(response).length !==0){
                           await store.dispatch("getSocieteVisiteMedicaleStats",response.id)
                            await store.dispatch("getProgrammationsVisitesMedicales",response.id)
                        }
               
                    }
                )
                next()
                NProgress.done()
            },
            error => {
                error
                next()
                NProgress.done()
                store.commit('SET_SOCIETE', null)

            }
        )

    },
    computed: {
        programmations(){
            return this.$store.getters["currentProgrammationLists"]
        },
        latestVisiteEnCours(){
            return this.$store.getters["latestVisiteMedicaleAnnuelle"]
        },
        societe() {
            return this.$store.getters["societe"]
        },

        difference_date() {
            return this.difference_between_dates(this.societe.contrat[0].debut_contrat, this.societe.contrat[0].fin_contrat)
        },

        canSeeContratEnCours() {
            console.log("call on see contrat")
            let curr_date = new Date(); //  Date courante
            let estValide

            if (this.societe.contrat && this.societe.contrat[0]) {
                let ended_contrat_date = this.societe.contrat[0].fin_contrat //  Date de fin du contrat

                let currdate = curr_date.getTime()
                let endcontrat = new Date(ended_contrat_date)
                endcontrat = endcontrat.getTime()

                let diff = endcontrat - currdate
                
                if (diff > 0) {
                    this.canReconduireContrat = false
                    this.canRompreContrat = true

                    estValide = true //  Contrat en cours
                    if (this.societe.contrat[0].valide == false || this.societe.contrat[0].valide == 0) {
                        estValide = false

                        this.canReconduireContrat = true
                        this.canRompreContrat = false
                    }

                } else {
                    estValide = false

                    this.canReconduireContrat = true
                    this.canRompreContrat = false
                }
            } else {
                estValide = false
            }

            return estValide
        }
        
    },
    mounted() {
        this.asset_url = this.assets_path+'/files'

        let societe_id = this.$route.params.id
        this.$store.dispatch("getSocieteVisitesMedicales",{sous_categorie_id:3,societe_id:societe_id,date:""})
        // if( Object.keys(this.latestVisiteEnCours).length >0){
         
        // }
        if(this.$route.params.params === "parametrage"){
            this.$refs.parametragesTab.click()
        }
        
        
        //this.$store.dispatch("getProgrammationsVisitesMedicales")     
        console.log('calendar')
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);
        this.$store.dispatch("getSociete", this.$route.params.id)

        if (this.$route.params.travailleurs == "travailleurs") {
            setTimeout(() => {
                this.$refs.soc_travailleur.click()
            }, 500);
        }

        if (this.$route.params.params == "parametrage") {
            setTimeout(() => {
                this.$refs.soc_parametrage.click()
            }, 500);
        }

        // =====================
        // let curr_date = new Date();                              //  Date courante
        // let ended_contrat_date = this.societe.contrat[0].fin_contrat    //  Date de fin du contrat
        // let contratEstenRupture = this.societe.contrat[0].valide
        // this.checkContratStatut(curr_date, ended_contrat_date, contratEstenRupture)

    },
    methods: {
        changeTab(tabindex, t) {

            if (t == 1) {
                // $('#hidden-tab-'+tabindex).addClass('active show');
                $('#shown-tab-' + tabindex).addClass('active show');

                for (let i = 1; i <= 6; i++) {
                    if (i != tabindex) {
                        // $('#hidden-tab-'+i).removeClass('active show');
                        $('#shown-tab-' + i).removeClass('active show');
                    }
                }
            } else {
                $('#hidden-tab-' + tabindex).addClass('active show');
                // $('#shown-tab-'+tabindex).addClass('active show');

                for (let i = 1; i <= 6; i++) {
                    if (i != tabindex) {
                        $('#hidden-tab-' + i).removeClass('active show');
                        // $('#shown-tab-'+i).removeClass('active show');
                    }
                }
            }


        },
        computeDays(debutDate, finDate) {

            let objDebut = moment(new Date(debutDate))
            let objFin = moment(new Date(finDate))


            let diffTime = objFin.diff(objDebut, 'year')

            let months = objFin.diff(objDebut, 'months');
            objFin.add(months, 'months')
            let days = objFin.diff(objDebut, 'days');

            let diffYears = { 'years': diffTime, 'months': months % 12, 'days': days % 30 };
            return diffYears;
        },

        difference_between_dates(begin, end) {

            let b = moment(new Date(begin)).toDate();
            let e = moment(new Date(end)).toDate();


            let bMonth = b.getMonth();
            let bYear = b.getFullYear();
            let eYear = e.getFullYear();
            let eMonth = e.getMonth();
            let bDay = b.getDate();
            let eDay = e.getDate() + 1;

            let eDays = 0,
                bDays = 0;

            if ((eMonth == 0) || (eMonth == 2) || (eMonth == 4) || (eMonth == 6) || (eMonth == 7) || (eMonth == 9) || (eMonth == 11))

            {
                eDays = 31;
            }

            if ((eMonth == 3) || (eMonth == 5) || (eMonth == 8) || (eMonth == 10))

            {
                eDays = 30;
            }

            if (eMonth == 1 && ((eYear % 4 == 0) && (eYear % 100 != 0)) || (eYear % 400 == 0)) {
                eDays = 29;
            }

            if (eMonth == 1 && ((eYear % 4 != 0) || (eYear % 100 == 0))) {
                eDays = 28;
            }


            if ((bMonth == 0) || (bMonth == 2) || (bMonth == 4) || (bMonth == 6) || (bMonth == 7) || (bMonth == 9) || (bMonth == 11))

            {
                bDays = 31;
            }

            if ((bMonth == 3) || (bMonth == 5) || (bMonth == 8) || (bMonth == 10))

            {
                bDays = 30;
            }

            if (bMonth == 1 && ((bYear % 4 == 0) && (bYear % 100 != 0)) || (bYear % 400 == 0)) {
                bDays = 29;
            }

            if (bMonth == 1 && ((bYear % 4 != 0) || (bYear % 100 == 0))) {
                bDays = 28;
            }


            let FirstMonthDiff = bDays - bDay + 1;


            if (eDay - bDay < 0) {

                eMonth = eMonth - 1;
                eDay = eDay + eDays;

            }

            let daysDiff = eDay - bDay;

            if (eMonth - bMonth < 0) {
                eYear = eYear - 1;
                eMonth = eMonth + 12;
            }

            let monthDiff = eMonth - bMonth;

            let yearDiff = eYear - bYear;

            if (daysDiff == eDays) {
                daysDiff = 0;
                monthDiff = monthDiff + 1;

                if (monthDiff == 12) {
                    monthDiff = 0;
                    yearDiff = yearDiff + 1;
                }

            }

            if ((FirstMonthDiff != bDays) && (eDay - 1 == eDays))

            {
                daysDiff = FirstMonthDiff;

            }
            let diffYears = { 'years': yearDiff, 'months': monthDiff, 'days': daysDiff };

            return diffYears;

        },

        rompreContrat() {
            this.societe_id = this.$route.params.id
        },

        showContrat(contrat) {
            let typeoffile = typeof contrat.fichier
            if (typeoffile == 'string' && contrat.fichier != '') {
                this.contrat = contrat.fichier
                console.log("--> CONTRAT: ", typeof contrat.fichier)
            } else {
                this.contrat = ''

            }
        },

        /**
         * Verifier le statut d'un contrat par raport à la date courante
         */
        checkContratStatut(curr_date, end_contrat_date, estValide) {
            let currdate = curr_date.getTime()
            let endcontrat = new Date(end_contrat_date)
            endcontrat = endcontrat.getTime()

            let diff = endcontrat - currdate
            if (diff > 0) { //  Contrat en cours
                this.canReconduireContrat = false
                this.canRompreContrat = true

                if (estValide == false) {
                    this.canReconduireContrat = true
                    this.canRompreContrat = false
                }
            } else {
                this.canReconduireContrat = true
                this.canRompreContrat = false
            }
        }
    }
}